import React, {Component} from "react";
import './ViewAllOrders.css';
import AllOrdersTable from '../ViewAllOrders/AllOrdersTable/AllOrdersTable';
import ReactGA from "react-ga";
import {GOOGLE_ANALYTICS_CODE} from "../../../../configuration";

class OrderHistory extends Component {

    constructor(props) {
        super(props);
    }

    render(){
        ReactGA.initialize(GOOGLE_ANALYTICS_CODE);
        ReactGA.pageview(window.location.pathname + window.location.search);
        return(
            <div className="all-order-content">
                <div className="all-order-div">
                    <AllOrdersTable userId = {this.props.userId}/>
                </div>
            </div>
        )
    }
}
export default OrderHistory;


// WEBPACK FOOTER //
// ./src/components/Admin/Order/ViewAllOrders/ViewAllOrders.js